(function () {
    'use strict';

    angular
        .module('app.tags')
        .controller('TagsAddController', AddController);

    AddController.$inject = ['$location', 'TagsService'];

    function AddController($location, Service) {
        /* jshint validthis:true */
        var vm = this;

        vm.entity = {};

        vm.fields = Service.getFields();

        vm.create = function () {
            if (vm.form.$valid) {
                vm.loading = true;
                Service.add(vm.entity)
                    .then(function (data) {
                        vm.loading = false;
                        $location.path('/tags/detail/' + data.Id);
                    });
            }
        };
    }
})();